import React, { useEffect, useState } from "react";
import TopNavbar from "../../CommonComponent/topNavbar/TopNavbar";
import Sidebar from "../../CommonComponent/sidebar/Sidebar";
import { Button, Col, Row } from "react-bootstrap";
import DataTable from "react-data-table-component";
import {
  SecodaryBidHistory,
  SecodaryBidHistoryData,
  SecondaryMarketMyBidHistory,
  SecondaryMarketMyBidHistoryData,
} from "../../redux/auth-reducer/auth-service";
import { Footer } from "../../Footer";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import Form from "react-bootstrap/Form";
import * as icons from "react-bootstrap-icons";

export const SecodaryBid = () => {
  const [data, setData] = useState(false);
  const [sidebar, setSidebar] = useState(false);
  const [apiData, setApiData] = useState([]);
  const [apiDataMyBid, setApiDataMyBid] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [searchTextMyBid, setsearchTextMyBid] = useState("");
  const [totalRows, setTotalRows] = useState(1);
  const [totalRowsMybid, setTotalRowsMybid] = useState(1);

  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const pageOptions = [10, 20, 30, 50];
  const [count, setCount] = useState(0);
  function sidebarfun() {
    setSidebar(!sidebar);
  }
  const [key, setKey] = useState(() => {
    return localStorage.getItem("activeTabBid") || "All Bids";
  });

  useEffect(() => {
    localStorage.setItem("activeTabBid", key);
  }, [key]);
  // useEffect(() => {
  //     dataApi()
  // }, [count]);

  // const dataApi = async (event) => {
  //     await SecodaryBidHistory().then((res) => {
  //         setApiData(res?.data?.data.dataList)
  //     })
  // }

  const dataApi = async (data) => {
    try {
      const response = await SecodaryBidHistoryData(data); // Call your API function
      if (response?.data) {
        setApiData(response.data.data.dataList || []); // Set the item list
        setTotalRows(response.data.data.totalPageSize || 0); // Set the total number of rows
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  // Effect to fetch data when current page changes
  useEffect(() => {
    const data = {
      PageNumber: currentPage,
      PageSize: perPage,
      SortOrder: true,
    };
    dataApi(data); // Fetch data when currentPage changes
  }, [currentPage, count, key]); // Dependency on currentPage

  const handlePerPageChange = (event) => {
    const newPerPage = Number(event.target.value);

    const data = {
      PageNumber: currentPage,
      PageSize: newPerPage,
      SortOrder: false,
    };
    dataApi(data);

    setPerPage(newPerPage); // Update items per page
    setCurrentPage(1); // Reset to first page when items per page changes
  };

  const handlePerPageChange1 = (event) => {
    const newPerPage = Number(event.target.value);

    const data = {
      PageNumber: currentPage,
      PageSize: newPerPage,
      SortOrder: false,
    };
    GetMyBids(data);

    setPerPage(newPerPage); // Update items per page
    setCurrentPage(1); // Reset to first page when items per page changes
  };

  // Handle page change
  const handleNextPage = () => {
    if (currentPage < Math.ceil(totalRows)) {
      setCurrentPage((prevPage) => prevPage + 1); // Go to next page
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prevPage) => prevPage - 1); // Go to previous page
    }
  };

  const handleNextPage1 = () => {
    if (currentPage < Math.ceil(totalRowsMybid)) {
      setCurrentPage((prevPage) => prevPage + 1); // Go to next page
    }
  };

  const handlePreviousPage1 = () => {
    if (currentPage > 1) {
      setCurrentPage((prevPage) => prevPage - 1); // Go to previous page
    }
  };

  const GetMyBids = async (data) => {
    try {
      const response = await SecondaryMarketMyBidHistoryData(data); // Call your API function
      if (response?.data) {
        setApiDataMyBid(response.data.data.dataList || []); // Set the item list
        setTotalRowsMybid(response.data.data.totalPageSize || 0); // Set the total number of rows
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  // Effect to fetch data when current page changes
  useEffect(() => {
    const data = {
      PageNumber: currentPage,
      PageSize: perPage,
      SortOrder: false,
    };
    GetMyBids(data); // Fetch data when currentPage changes
  }, [currentPage, count]);

  const columns = [
    {
      name: "id",
      selector: (row, index) => index + 1,

      width: "80px",
    },
    {
      name: "Team Name",
      selector: (row) => row?.teamName,
      sortable: true,
    },
    {
      name: "Auction Name",
      selector: (row) => row?.auctionName,
      sortable: true,
    },

    {
      name: "Bid Increment",
      selector: (row) => row?.bidIncrement,
      sortable: true,
    },
    {
      name: "Total Placed Bids",
      selector: (row) => row?.totalPlacedBids,
      sortable: true,
    },

    {
      name: "Bid Time",
      selector: (row) => row?.bidTime,
      sortable: true,
    },
    {
      name: "Bid Amount",
      selector: (row) => row?.currentBidAmount,
      sortable: true,
    },
    {
      name: "Ownership Sell",
      selector: (row) => row?.ownerShip,
      sortable: true,
    },
  ];

  const columnsMyBid = [
    {
      name: "id",
      selector: (row, index) => index + 1,

      width: "80px",
    },
    {
      name: "Team Name",
      selector: (row) => row?.teamName,
      sortable: true,
    },
    {
      name: "Auction Name",
      selector: (row) => row?.auctionName,
      sortable: true,
    },

    {
      name: "Bid Increment",
      selector: (row) => row?.bidIncrement,
      sortable: true,
    },
    {
      name: "Level",
      selector: (row) => row?.auctionLevel,
      sortable: true,
    },

    {
      name: "Bid Time",
      selector: (row) => row?.bidTime,
      sortable: true,
    },
    {
      name: "Starting Bid",
      selector: (row) => row?.startingBid,
      sortable: true,
    },

    {
      name: "Bid Amount",
      selector: (row) => row?.myBidAmount,
      sortable: true,
    },
  ];

  const handleSearch = (e) => {
    setSearchText(e.target.value);
  };
  const handleSearchMyBid = (e) => {
    setsearchTextMyBid(e.target.value);
  };

  const filterDataAllBids = searchText
    ? apiData.filter((item) => {
        return (
          item?.auctionName
            ?.toLowerCase()
            .includes(searchText?.toLowerCase()) ||
          item?.teamName?.toLowerCase().includes(searchText?.toLowerCase())
        );
      })
    : apiData;

  const filterDataMyBids = searchTextMyBid
    ? apiDataMyBid.filter((item) => {
        return (
          item?.auctionName
            ?.toLowerCase()
            .includes(searchTextMyBid?.toLowerCase()) ||
          item?.teamName?.toLowerCase().includes(searchTextMyBid?.toLowerCase())
        );
      })
    : apiDataMyBid;

  const clearSearch = () => {
    setSearchText("");
    setsearchTextMyBid("");
  };
  return (
    <>
      <TopNavbar sidebarfun={sidebarfun} />
      <div className="dasboard-group">
        <Sidebar data={sidebar} />
        <div
          className={
            sidebar ? "dashboard-content full-contnet" : "dashboard-content"
          }
        >
          <h1 className="heading-dash">Secondary Market</h1>
          <div className="group_data_table">
            <div className="group_data_table tabs-auction">
              <div className="tabs-box">
                <Tabs
                  id="auctiontabs"
                  activeKey={key}
                  onSelect={(k) => setKey(k)}
                  // onSelect={handleTabChange}
                  className="mb-0 tab-list-item"
                  justify
                >
                  <Tab eventKey="All Bids" title="All Bids">
                    <div>
                      <div className="search-input d-flex align-items-center">
                        <input
                          type="text"
                          className="form-control mb-3 mt-3"
                          placeholder="Search..."
                          value={searchText}
                          onChange={handleSearch}
                        />
                        {searchText && (
                          <button
                            className="btn btn-clear"
                            onClick={clearSearch}
                          >
                            <span>&times;</span>{" "}
                            {/* This represents the close icon */}
                          </button>
                        )}
                      </div>

                      {/* <DataTable
                                            title="dfsfd"
                                            columns={columns}
                                            data={filterDataAllBids}
                                            pagination
                                            paginationPerPage={10}
                                            paginationRowsPerPageOptions={[5, 10, 15, 20]}
                                            paginationTotalRows={filterDataAllBids?.length}
                                        /> */}
                      <div>
                        <DataTable
                          // title="Sport List"
                          columns={columns}
                          data={filterDataAllBids}
                          paginationPerPage={perPage}
                          paginationTotalRows={totalRows * 10}
                          paginationDefaultPage={currentPage}
                          onChangePage={setCurrentPage}
                        />
                        {totalRows > 1 && (
                          <Row>
                            <Col md={12} className="text-right">
                              <div className="pagination-controls">
                                <label>Rows page: </label>
                                <select
                                  id="itemsPerPage"
                                  value={perPage}
                                  onChange={handlePerPageChange}
                                >
                                  {pageOptions.map((option) => (
                                    <option key={option} value={option}>
                                      {option}
                                    </option>
                                  ))}
                                </select>

                                <Button
                                  onClick={handlePreviousPage}
                                  disabled={currentPage === 1}
                                >
                                  <icons.ArrowLeft></icons.ArrowLeft>
                                </Button>
                                <span>
                                  {" "}
                                  {currentPage} of {totalRows}{" "}
                                </span>
                                <Button
                                  onClick={handleNextPage}
                                  disabled={currentPage >= Math.ceil(totalRows)}
                                >
                                  <icons.ArrowRight></icons.ArrowRight>
                                </Button>
                              </div>
                            </Col>
                          </Row>
                        )}
                      </div>
                    </div>
                  </Tab>

                  <Tab eventKey="My Bids" title="My Bids">
                    <div>
                      <div className="search-input filter auction-filter palyer">
                        <input
                          type="text"
                          className="form-control mb-3 mt-3"
                          placeholder="Search..."
                          value={searchTextMyBid}
                          onChange={handleSearchMyBid}
                        />
                        {searchTextMyBid && (
                          <button
                            className="btn btn-clear"
                            onClick={clearSearch}
                          >
                            <span>&times;</span>{" "}
                            {/* This represents the close icon */}
                          </button>
                        )}
                      </div>

                      {/* <DataTable
                                                columns={columnsMyBid}
                                                data={filterDataMyBids}
                                                pagination
                                                paginationPerPage={10}
                                                defaultSortFieldId={1}
                                                paginationRowsPerPageOptions={[10, 20, 30]}
                                            /> */}

                      <div>
                        <DataTable
                          // title="Sport List"
                          columns={columnsMyBid}
                          data={filterDataMyBids}
                          paginationPerPage={perPage}
                          paginationTotalRows={totalRowsMybid * 10}
                          paginationDefaultPage={currentPage}
                          onChangePage={setCurrentPage}
                        />
                        {totalRowsMybid > 1 && (
                          <Row>
                            <Col md={12} className="text-right">
                              <div className="pagination-controls">
                                <label>Rows per page: </label>
                                <select
                                  id="itemsPerPage"
                                  value={perPage}
                                  onChange={handlePerPageChange1}
                                >
                                  {pageOptions.map((option) => (
                                    <option key={option} value={option}>
                                      {option}
                                    </option>
                                  ))}
                                </select>

                                <Button
                                  onClick={handlePreviousPage1}
                                  disabled={currentPage === 1}
                                >
                                  <icons.ArrowLeft></icons.ArrowLeft>
                                </Button>
                                <span>
                                  {currentPage} of {totalRowsMybid}{" "}
                                </span>
                                <Button
                                  onClick={handleNextPage1}
                                  disabled={
                                    currentPage >= Math.ceil(totalRowsMybid)
                                  }
                                >
                                  <icons.ArrowRight></icons.ArrowRight>
                                </Button>
                              </div>
                            </Col>
                          </Row>
                        )}
                      </div>
                    </div>
                  </Tab>
                </Tabs>
              </div>
            </div>
          </div>
        </div>
        <div className={data ? "Footer" : "footer-content"}>
          <Footer />
        </div>
      </div>
    </>
  );
};
